export function ChatAiLoadingIcon({ dataTestId }: { dataTestId?: string }) {
  return (
    <span className="inline-flex items-center ml-1" data-testid={dataTestId}>
      <span className="animate-pulse text-gray-400">
        <span
          className="animate-bounce inline-block w-1 h-1 bg-gray-400 rounded-full mr-1"
          style={{ animationDelay: '0ms' }}
        ></span>
        <span
          className="animate-bounce inline-block w-1 h-1 bg-gray-400 rounded-full mr-1"
          style={{ animationDelay: '150ms' }}
        ></span>
        <span
          className="animate-bounce inline-block w-1 h-1 bg-gray-400 rounded-full"
          style={{ animationDelay: '300ms' }}
        ></span>
      </span>
    </span>
  );
}
